import { useGetAssessmentHistory } from "@/api/app/history/useGetAssessmentHistory";
import AppContentContainer from "@/src/app/(auth)/_components/AppContentContainer";
import HistoryTable from "@/src/app/(auth)/history/_components/HistoryTable";
import { useTranslation } from "react-i18next";

function AssessmentHistory() {
  const { t } = useTranslation();
  const { data, isLoading } = useGetAssessmentHistory();

  return (
    <AppContentContainer className="mx-32 my-8">
      <div className="text-2xl font-bold mb-8">{t("assessment-history")}</div>
      <HistoryTable data={data?.data ?? []} isLoading={isLoading} />
    </AppContentContainer>
  );
}

export default AssessmentHistory;